import gql from 'graphql-tag';
const PUBLISH_DEMOGRAPH_AUDIENCE = gql`
  mutation publishDemographAudience($data: JSON!) {
    publishDemographAudience(data: $data)
  }
`;

export default PUBLISH_DEMOGRAPH_AUDIENCE;
